module.exports = __webpack_public_path__ + "img/807c578a94a10a743aa1de7c1ac299f6.svg";